export default "__VITE_ASSET__Drrgetvt__"